import { useDispatch, useSelector } from 'react-redux';
import { ProviderProps } from './props';
import { handleProviderFilter } from '@/lib/store/casino/actions';
import { RootState } from '@/lib/store';
import { memo, useMemo } from 'react';
import { Checkbox } from '@starsoft/common/components';
import styles from './styles.module.scss';

function Provider({ data, isLoading }: ProviderProps) {
  const dispatch = useDispatch();
  const providers: bigint[] = useSelector(
    (state: RootState) => state.casino.providersList,
  );
  const isChecked = useMemo(
    () => providers.includes(data?.id as bigint),
    [data?.id, providers],
  );

  function handleProvider(id: bigint) {
    dispatch(handleProviderFilter(id));
  }

  if (isLoading) {
    return (
      <div className={styles.container}>
        <Checkbox isLoading onClick={() => {}} />
        <div className={styles['container__text-skeleton']} />
      </div>
    );
  }

  return (
    <div
      className={styles.container}
      onClick={() => handleProvider(data?.id as bigint)}
    >
      <Checkbox onClick={() => {}} isChecked={isChecked} />
      <span className={styles.container__label}>{data?.name}</span>
    </div>
  );
}

export default memo(Provider);
